module.exports = __webpack_public_path__ + "img/offer.75a02e59.svg";